import { handleClientError } from "lib/errors";
import { groq } from "next-sanity";
import { getClient } from "../sanity";

export type Customer = {
  slug: string;
  name: string;
  website: string;
  about?: string;
  logoUrl: string;
  logoMonoUrl?: string;
};

export const customerFragment =
  "slug, name, website, about, 'logoUrl': logo.asset->url, 'logoMonoUrl': logoMonotone.asset->url";

export const getFeaturedCustomers = async (slugs: string[]): Promise<Customer[]> => {
  const query = groq`
    *[_type == "customer" && slug in $slugs] {
      ${customerFragment}
    }
  `;
  const parameters = { slugs };
  const unorderedCustomers: Customer[] = await getClient().fetch(query, parameters);
  const orderedCustomers: Customer[] = [];

  // Return the customers in the same order they were requested
  for (const slug of slugs) {
    const customer = unorderedCustomers.find((customer: Customer) => customer.slug === slug);

    if (customer) {
      orderedCustomers.push(customer);
    } else {
      handleClientError(
        `There was an issue loading featured customers from Sanity. Expected a customer with slug '${slug}' to exist.`,
      );
    }
  }

  return orderedCustomers;
};
